/** Veri yaşı gibi göreli süreler: "3 dk önce". */
export function fmtAge(ms: number): string {
  const min = Math.floor(ms / 60_000);
  if (min < 1) return "az önce";
  if (min < 60) return `${min} dk önce`;
  const h = Math.floor(min / 60);
  if (h < 48) return `${h} sa önce`;
  return `${Math.floor(h / 24)} gün önce`;
}
